import { Tag } from "antd";
import { FC } from "react";

interface Props {
    options: { label: string; value: string }[];
    value: string[];
    onChange: (value: string[]) => void;
}

export const TagSelect: FC<Props> = ({ options, value = [], onChange }) => {
    const toggleValue = (tag: string) => {
        if (value.includes(tag)) {
            onChange(value.filter(v => v !== tag));
        } else {
            onChange([...value, tag]);
        }
    };

    return (
        <div className="flex flex-wrap">
            {options.map(option => (
                <Tag.CheckableTag
                    key={option.value}
                    onClick={() => toggleValue(option.value)}
                    checked={value.includes(option.value)}
                    className="cursor-pointer select-none px-3 py-1 rounded-full text-sm"
                >
                    {option.label}
                </Tag.CheckableTag>
            ))}
        </div>
    );
}
